var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "67.965 110 360.1 240",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69 343 c-4 -23 4 -49 17 -59 9 -7 15 -34 16 -78 1 -36 5 -61 9 -54 12 20 86 10 126 -17 19 -14 43 -25 52 -25 37 0 109 68 96 90 -4 6 5 10 21 10 22 0 25 2 14 15 -10 12 -10 18 1 32 9 10 9 14 2 10 -7 -5 -17 1 -23 13 -6 12 -17 19 -23 17 -7 -3 -24 7 -39 21 -15 14 -31 23 -34 19 -4 -4 3 -15 16 -25 l23 -19 -34 -23 c-32 -23 -33 -23 -15 -2 11 12 15 22 10 22 -5 0 -18 7 -28 15 -16 12 -17 17 -6 30 9 11 9 15 1 15 -18 0 -24 -26 -12 -49 10 -18 8 -21 -15 -27 -16 -4 -31 -2 -40 8 -12 12 -12 17 6 36 12 12 17 22 12 22 -13 0 -39 -32 -47 -58 l-7 -24 -22 21 c-12 12 -33 21 -45 21 -19 0 -23 4 -19 25 3 14 1 25 -3 25 -5 0 -10 -3 -10 -7z m285 -87 c-6 -16 -24 -23 -24 -8 0 10 22 33 27 28 2 -2 1 -11 -3 -20z",
    fill: "#000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIcon);
export default __webpack_public_path__ + "static/media/logo-icon.900bc21a1ffc3ae4d8ba6987c96f8c83.svg";
export { ForwardRef as ReactComponent };